import React from "react";
import { Grid, Paper, Skeleton, Box } from "@mui/material";

const SandboxOptionsSkeleton = () => {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      {/* Title */}
      <Skeleton variant="text" width="40%" height={35} sx={{ mb: 2 }} />

      {/* Search + Button */}
      <Grid container justifyContent="space-between" alignItems="center" spacing={2} mb={2}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={40} width="60%" />
        </Grid>
        <Grid item xs={12} sm={6} display="flex" justifyContent="flex-end">
          <Skeleton variant="rectangular" height={40} width={180} />
        </Grid>
      </Grid>

      {/* Table Header */}
      <Grid container spacing={2} mb={1}>
        <Grid item xs={1}><Skeleton variant="text" width={20} /></Grid>
        <Grid item xs={1}><Skeleton variant="text" width={30} /></Grid>
        <Grid item xs={2}><Skeleton variant="text" width={60} /></Grid>
        <Grid item xs={4}><Skeleton variant="text" width={80} /></Grid>
        <Grid item xs={2}><Skeleton variant="text" width={70} /></Grid>
        <Grid item xs={2}><Skeleton variant="text" width={60} /></Grid>
      </Grid>

      {/* Table Rows */}
      {[...Array(4)].map((_, index) => (
        <Grid container spacing={2} key={index} alignItems="center" mb={1}>
          <Grid item xs={1}><Skeleton variant="circular" width={20} height={20} /></Grid>
          <Grid item xs={1}><Skeleton variant="text" width={30} /></Grid>
          <Grid item xs={2}><Skeleton variant="text" width={60} /></Grid>
          <Grid item xs={4}><Skeleton variant="text" width="90%" /></Grid>
          <Grid item xs={2}><Skeleton variant="text" width="80%" /></Grid>
          <Grid item xs={2} display="flex" gap={1}>
            {[...Array(3)].map((_, iconIdx) => (
              <Skeleton key={iconIdx} variant="circular" width={24} height={24} />
            ))}
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default SandboxOptionsSkeleton;
